module.exports = __webpack_public_path__ + "assets/img/LOGO.c1f8f07d.png";